import React from 'react';
import Footer from './footer.jsx';
import { Link } from 'react-router-dom';

const partners = [
  {
    name: 'ZimParks',
    description: 'Zimbabwe Parks and Wildlife Management Authority. IROD is deployed in select national parks, helping rangers monitor wildlife and prevent poaching.',
    link: 'https://zimparks.org.zw/',
  },
  {
    name: 'Kumba Shiri Nature Reserve',
    description: 'A leading nature reserve on Lake Chivero, Zimbabwe. IROD supports conservation and animal monitoring at Kumba Shiri.',
    link: 'https://www.facebook.com/kumbashiri/',
  },
  {
    name: 'Matopo Resource',
    description: 'Matobo National Park and surrounding conservancies. IROD assists in wildlife tracking and anti-poaching efforts.',
    link: 'https://en.wikipedia.org/wiki/Matobo_National_Park',
  },
  {
    name: 'Starlink',
    description: 'Starlink provides satellite internet, enabling IROD to operate in remote areas with reliable connectivity.',
    link: 'https://www.starlink.com/',
  },
];

export default function PartnerUs() {
  return (
    <>
      <nav style={{ width: '100%', background: 'rgba(10,17,40,0.97)', borderBottom: '1px solid #1e293b22', padding: '12px 0', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'sticky', top: 0, zIndex: 100 }}>
        <Link to="/" style={{ color: '#fff', fontWeight: 700, fontSize: '1.2rem', textDecoration: 'none', letterSpacing: '0.01em' }}>IROD Home</Link>
      </nav>
      <div style={{ maxWidth: 900, margin: '40px auto', padding: '32px 16px', background: 'rgba(18,24,38,0.97)', borderRadius: '1.2rem', color: '#e5e7eb', boxShadow: '0 2px 24px 0 rgba(30,40,90,0.13)' }}>
        <h1 style={{ fontSize: '2.2rem', fontWeight: 800, marginBottom: 16 }}>Our Partners</h1>
        <p style={{ marginBottom: 24 }}>IROD is proud to work with leading conservation organizations and technology partners. Together, we are making a real impact in wildlife protection and connectivity in Africa.</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
          {partners.map((p, i) => (
            <div key={i} style={{ background: 'rgba(30,40,90,0.18)', borderRadius: '1rem', padding: '20px 18px', boxShadow: '0 1px 8px 0 rgba(30,40,90,0.10)' }}>
              <h2 style={{ fontSize: '1.3rem', color: '#6366f1', margin: 0 }}>{p.name}</h2>
              <p style={{ margin: '8px 0 0 0', color: '#b6c3e0' }}>{p.description}</p>
              <a href={p.link} target="_blank" rel="noopener noreferrer" style={{ color: '#0ea5e9', fontWeight: 500, fontSize: '1em', marginTop: 8, display: 'inline-block' }}>Learn more</a>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 40, color: '#b6c3e0', fontSize: '1em' }}>
          <p>Want to partner with us? <a href="mailto:info@visyntech.co.zw" style={{ color: '#6366f1' }}>Contact us</a> to discuss collaboration opportunities.</p>
        </div>
      </div>
      <Footer />
    </>
  );
}
